
const LandingHeroHeading = ({ children, additionalclasses }) => {
    return (
        <p className={`text-[40px] lg:text-[68px] leading-[40px] lg:leading-[74px] tracking-[-0.68px] text-white text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default LandingHeroHeading;